import { render, staticRenderFns } from "./ConfigManager.vue?vue&type=template&id=b3f4dfda"
import script from "./ConfigManager.vue?vue&type=script&lang=js"
export * from "./ConfigManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports